 import React, { Component } from 'react';
 import { withStyles } from '@material-ui/core/styles';
 import { Drawer, AppBar, Toolbar, List, ListItem, ListItemText, Collapse, Typography, IconButton, Hidden, Divider, Button } from '@material-ui/core';
 import { BrowserRouter, Route, Link } from 'react-router-dom';
 import { Menu, ExpandLess, ExpandMore, } from '@material-ui/icons';
 import whiteLogo from '../../images/logo-in-white.png'
 import whiteLogoText from '../../images/WhiteLL.png'
 import creds from '../../config/firebaseConfig';
 import db from '../../config/firestoreConfig';


 const drawerWidth = 400;

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'auto',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  signOut: { 
     marginRight: 0,
     marginLeft: 'auto',
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
})


class SideDrawer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileOpen: false,
      Courses: false,
      Classes: false,
      Tests: false,
      levels: []
    };
  }


     componentDidMount (){
      console.log('component did mount')
        this.currentUser( async (setAccountType) => {
          console.log('setting Account Type')
          var ref = await db.collection('Users').get()
          ref.forEach(record => {
            console.log(this.state.currentEmail)
            if (record.data().email == this.state.currentEmail){
              sessionStorage.setItem('AccountType', record.data().accountType)
              //  console.log(sessionStorage.getItem('AccountType'))    //Debug line
            }
          })
        })
        if (sessionStorage.getItem('AccountType', 'Teacher')){
          var levels = [] 
          db.collection('Level').get()
          .then(snapshot => {
            snapshot.forEach(record => {
              var ref = db.collection('Level').doc(record.id);
              var level = []
              level.push(record.id)
              ref.collection('Subjects').get()
              .then(snapshot => {
                snapshot.forEach(Subject => {
                  // console.log(Subject.data())
                  const obj = {
                    [Subject.id] : Subject.data()
                  }
                  level.push(obj)
                  // console.log(level)
                  // console.log(Subject.data())
                })
              })
              const obj = { [record.id] : level}
              levels.push(obj)
            })
          })
          
          this.setState({
            ...this.state, 
            levels: levels
          })
          console.log(this.state.levels)
        }   
      };

      handleClick = (name) => {
        this.setState(state => ({ [name]: !state[name] }));
      };
    

      signOut = () => { 
          creds.fb.auth().signOut()
            .then( 
              window.location.replace('/'),
              sessionStorage.clear(),
              
            )
            .catch((error) => { 
                console.log(error)
            })
      };

      
    
      

      customMenu = () => {
        switch(sessionStorage.getItem('AccountType')) {
          case 'Student' :
            return (
              <div style={{width: '100%'}}>
                <List component='nav'>
                  <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/' + sessionStorage.getItem('AccountType') + '/Dashboard')}>
                    <ListItemText  primary='Dashboard'/>
                  </ListItem>
                  <ListItem button onClick={() => this.handleClick('Courses')}>
                    <ListItemText  primary='Academic Levels'/>
                    {this.state.Courses ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.Courses} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/mysubjects')} >
                        <ListItemText inset primary="My Academic Level" />
                      </ListItem>
                      <ListItem button onClick={() => this.handleClick('Levels')}>
                        <ListItemText  inset primary='All Academic Levels'/>
                        {this.state.Levels ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                      <Collapse in={this.state.Levels} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                        {this.state.levels.map( level => {
                          const name = Object.getOwnPropertyNames(level)[0]
                          return (
                          <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/levels/' + name)}>
                            <ListItemText inset primary={name} />
                          </ListItem>
                          )
                        })}
                        </List>
                      </Collapse>
                    </List>
                  </Collapse>
                      <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/viewhwk')}>
                        <ListItemText  primary="My Tasks" />
                      </ListItem>
                </List>
              </div>
            )
            break;
          case 'Teacher' : 
            return (
              <div style={{width: '100%'}}>
                <List component='nav'>
                <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/' + sessionStorage.getItem('AccountType') + '/Dashboard')}>
                    <ListItemText  primary='Dashboard'/>
                  </ListItem>
                  <ListItem button  onClick={() => this.handleClick('Accounts')}>
                    <ListItemText primary='Account Management'/>
                    {this.state.Accounts ? <ExpandLess/> : <ExpandMore/>}
                  </ListItem>
                  <Collapse in={this.state.Accounts} timeout='auto' unmountOnExit>
                    <List component='div' disablePadding>
                      <ListItem button  onClick={() => this.handleClick('Individuals')}>
                        <ListItemText primary='Individuals'/>
                        {this.state.Individuals ? <ExpandLess/> : <ExpandMore/>}
                      </ListItem>
                      <Collapse in={this.state.Individuals} timeout='auto' unmountOnExit>
                        <List component='div' disablePadding>
                          <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/accounts/create')}>
                            <ListItemText inset primary='Create Accounts'/>
                          </ListItem>
                          <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/accounts/edit')}>
                            <ListItemText inset primary='Edit Accounts'/>
                          </ListItem>
                          <ListItem button onClick={()  => window.location.replace('/' + this.state.currentUID + '/accounts/delete')}>
                            <ListItemText inset primary='Delete Accounts'/>
                          </ListItem>
                        </List>
                      </Collapse>
                      <ListItem button  onClick={() => this.handleClick('Groups')}>
                        <ListItemText primary='Groups'/>
                          {this.state.Groups ? <ExpandLess/> : <ExpandMore/>}
                      </ListItem>
                      <Collapse in={this.state.Groups} timeout='auto' unmountOnExit>
                        <List component='div' disablePadding>
                          <ListItem button onClick={()  => window.location.replace('/' + this.state.currentUID + '/groups/create')}>
                            <ListItemText inset primary='Create Groups'/>
                          </ListItem>
                          <ListItem button onClick={()  => window.location.replace('/' + this.state.currentUID + '/groups/edit')}>
                            <ListItemText inset primary='Edit Groups'/>
                          </ListItem>
                          <ListItem button onClick={()  => window.location.replace('/' + this.state.currentUID + '/groups/delete')}>
                            <ListItemText inset primary='Delete Groups'/>
                          </ListItem>
                        </List>
                      </Collapse>
                    </List>
                  </Collapse>
                  <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/' + sessionStorage.getItem('AccountType') + '/managelevels')}>
                    <ListItemText primary='Manage Academic Levels'/>
                  </ListItem>
                  <ListItem button onClick={() => this.handleClick('Levels')}>
                    <ListItemText primary=' View Academic Levels'/>
                    {this.state.Levels ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.Levels} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      
                    {this.state.levels.map( level => {
                      const name = Object.getOwnPropertyNames(level)[0]
                      return (
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/levels/' + name)}>
                        <ListItemText inset primary={name} />
                      </ListItem>
                      )
                    })}
                    </List>
                    </Collapse>
                     <ListItem button  onClick={() => this.handleClick('TaskMng')}>
                    <ListItemText primary='Task Management'/>
                        {this.state.TaskMng ? <ExpandLess/> : <ExpandMore/>}
                    </ListItem>
                    <Collapse in={this.state.TaskMng} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/tests/0/create')}>
                        <ListItemText inset primary="Create Tasks" />
                      </ListItem>
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/' + sessionStorage.getItem('AccountType') + '/edittasks')}>
                        <ListItemText inset primary="Edit Tasks" />
                      </ListItem>
                      </List>
                    </Collapse>
                  <ListItem button onClick={() => this.handleClick('SetWork')}>
                    <ListItemText primary=' Set Work'/>
                    {this.state.Levels ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.SetWork} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      
                    {this.state.levels.map( level => {
                      const name = Object.getOwnPropertyNames(level)[0]
                      return (
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/levels/' + name)}>
                        <ListItemText inset primary={name} />
                      </ListItem>
                      )
                    })}
                    </List>
                  </Collapse>
                  <ListItem button  onClick={() => this.handleClick('StuProgress')}>
                    <ListItemText primary='Student progress'/>
                      {this.state.StuProgress ? <ExpandLess/> : <ExpandMore/>}
                  </ListItem>
                  <Collapse in={this.state.StuProgress} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/tasks/view/performance2')}>
                        <ListItemText inset primary="View recent performance" />
                      </ListItem>
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/tasks/view/performance2g')}>
                            <ListItemText inset primary="View recent group performance" />
                          </ListItem>
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/tasks/view/student')}>
                        <ListItemText inset primary="View Students task list" />
                      </ListItem>
                    </List>
                  </Collapse>
                </List>
              </div>
            )
            break;
          case 'Parent' :
            return (
              <div style={{width: '100%'}}>
                <List component='nav'>
                <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/' + sessionStorage.getItem('AccountType') + '/Dashboard')}>
                    <ListItemText  primary='Dashboard'/>
                  </ListItem>
                  <ListItem button onClick={() => this.handleClick('Levels')}>
                    <ListItemText  primary='Academic Levels'/>
                    {this.state.Levels ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.Levels} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                    {this.state.levels.map( level => {
                      const name = Object.getOwnPropertyNames(level)[0]
                      return (
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/levels/' + name)}>
                        <ListItemText inset primary={name} />
                      </ListItem>
                      )
                    })}
                    </List>
                  </Collapse>
                </List>
              </div>
            )
            break;
          case 'Admin' :
          return (
            <div style={{width: '100%'}}>
                <List component='nav'>
                  <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/' + sessionStorage.getItem('AccountType') + '/Dashboard')}>
                    <ListItemText primary='Dashboard'/>
                  </ListItem>
                  <ListItem button  onClick={() => this.handleClick('Accounts')}>
                    <ListItemText primary='Account Management'/>
                    {this.state.Accounts ? <ExpandLess/> : <ExpandMore/>}
                  </ListItem>
                  <Collapse in={this.state.Accounts} timeout='auto' unmountOnExit>
                    <List component='div' disablePadding>
                      <ListItem button  onClick={() => this.handleClick('Individuals')}>
                        <ListItemText primary='Individuals'/>
                        {this.state.Individuals ? <ExpandLess/> : <ExpandMore/>}
                      </ListItem>
                      <Collapse in={this.state.Individuals} timeout='auto' unmountOnExit>
                        <List component='div' disablePadding>
                          <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/accounts/create')}>
                            <ListItemText inset primary='Create Accounts'/>
                          </ListItem>
                          <ListItem button onClick={() => window.location.replace('/' + this.state.currentUID + '/accounts/edit')}>
                            <ListItemText inset primary='Edit Accounts'/>
                          </ListItem>
                          <ListItem button onClick={()  => window.location.replace('/' + this.state.currentUID + '/accounts/delete')}>
                            <ListItemText inset primary='Delete Accounts'/>
                          </ListItem>
                        </List>
                      </Collapse>
                      <ListItem button  onClick={() => this.handleClick('Groups')}>
                        <ListItemText primary='Groups'/>
                          {this.state.Groups ? <ExpandLess/> : <ExpandMore/>}
                      </ListItem>
                      <Collapse in={this.state.Groups} timeout='auto' unmountOnExit>
                        <List component='div' disablePadding>
                          <ListItem button onClick={()  => window.location.replace('/' + this.state.currentUID + '/groups/create')}>
                            <ListItemText inset primary='Create Groups'/>
                          </ListItem>
                          <ListItem button onClick={()  => window.location.replace('/' + this.state.currentUID + '/groups/edit')}>
                            <ListItemText inset primary='Edit Groups'/>
                          </ListItem>
                          <ListItem button onClick={()  => window.location.replace('/' + this.state.currentUID + '/groups/delete')}>
                            <ListItemText inset primary='Delete Groups'/>
                          </ListItem>
                        </List>
                      </Collapse>
                    </List>
                  </Collapse>
                  <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/' + sessionStorage.getItem('AccountType') + '/managelevels')}>
                    <ListItemText primary='Manage Academic Levels'/>
                  </ListItem>
                  <ListItem button onClick={() => this.handleClick('Levels')}>
                    <ListItemText primary=' View Academic Levels'/>
                    {this.state.Levels ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.Levels} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      
                    {this.state.levels.map( level => {
                      const name = Object.getOwnPropertyNames(level)[0]
                      return (
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/levels/' + name)}>
                        <ListItemText inset primary={name} />
                      </ListItem>
                      )
                    })}
                      
                    </List>
                  </Collapse>
                  <ListItem button  onClick={() => this.handleClick('TaskMng')}>
                    <ListItemText primary='Task Management'/>
                        {this.state.TaskMng ? <ExpandLess/> : <ExpandMore/>}
                    </ListItem>
                      <Collapse in={this.state.TaskMng} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                        <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/tests/0/create')}>
                          <ListItemText inset primary="Create Tasks" />
                        </ListItem>
                        <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/' + sessionStorage.getItem('AccountType') + '/edittasks')}>
                          <ListItemText inset primary="Edit Tasks" />
                        </ListItem>
                        </List>
                      </Collapse>
                  <ListItem button onClick={() => this.handleClick('SetWork')}>
                    <ListItemText primary=' Set Work'/>
                    {this.state.Levels ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={this.state.SetWork} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      
                    {this.state.levels.map( level => {
                      const name = Object.getOwnPropertyNames(level)[0]
                      return (
                      <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/levels/' + name)}>
                        <ListItemText inset primary={name} />
                      </ListItem>
                      )
                    })}
                      
                    </List>
                  </Collapse>
                      <ListItem button  onClick={() => this.handleClick('StuProgress')}>
                      <ListItemText primary='Student progress'/>
                        {this.state.StuProgress ? <ExpandLess/> : <ExpandMore/>}
                      </ListItem>
                      <Collapse in={this.state.StuProgress} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/tasks/view/performance2')}>
                            <ListItemText inset primary="View recent student performance" />
                          </ListItem>
                          <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/tasks/view/performance2g')}>
                            <ListItemText inset primary="View recent group performance" />
                          </ListItem>
                          <ListItem button className={styles.nested} onClick={() => window.location.replace('/' + this.state.currentUID + '/tasks/view/student')}>
                            <ListItemText inset primary="View Students task list" />
                          </ListItem>
                        </List>
                      </Collapse>
                </List>
              </div>
          )
        }
      }

    //Need to add user name here to finish the personalisation for the side drawer 
    //but have to finish the account creation page first. 
    currentUser = () => {
      console.log(window.location.pathname)
      
      
        var user = creds.fb.auth().currentUser   
        user
        if (user) {
          this.setState({
            currentEmail: user.email,
            currentUID: user.uid,
            me: {
              'email': user.email,
              'uid': user.uid
            },
          }),
          sessionStorage.setItem('email', user.email),
          sessionStorage.setItem('uid', user.uid),
          db.collection('Users').where('UID', '==', user.uid).get()
            .then(snapshot => { 
              console.log(snapshot.docs)
              sessionStorage.setItem('AccountType', snapshot.docs[0].data().accountType)
              sessionStorage.setItem('DisplayName', snapshot.docs[0].data().displayName)
            })
          } 
      
    } 

      handleDrawerToggle = () => {
        this.setState(state => ({ mobileOpen: !state.mobileOpen }));
      };

     render (){
       

        const { classes, children  } = this.props;
        const { mobileOpen } = this.state


        const CustomMenu = { 
          
        }

        // this is where menu items will go. 
        // Can quite easily implement a nested list in here with links to pages. 
        const drawer = (
          <div>
            <Hidden smDown>
                <div className={classes.toolbar}/>
            </Hidden>
            <Typography variant='title' color='inherit' style={{padding: 25}}>
               Welcome Back, {sessionStorage.getItem('DisplayName')}
            </Typography>
            
            <Divider/>
            {this.customMenu()}
          </div>
        );

         

        return (
            <div className={classes.root}>
            <AppBar position="absolute" className={classes.appBar}>
              <Toolbar>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={this.handleDrawerToggle}
                  className={classes.navIconHide}
                >
                  <Menu />
                </IconButton>
                <div style={{marginRight: 10}}>
                <img height={32} width={32} src={whiteLogo}/>
                </div>
                <div style={{marginRight: 10}}>
                <img height={30} width='auto' src={whiteLogoText}/>
                </div>
                <Button className={classes.signOut} onClick={ () => {this.signOut()}} color='inherit'>
                    Sign Out
                </Button>
              </Toolbar>
            </AppBar>
            <Hidden mdUp>
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={this.handleDrawerToggle}
                classes={{
                  paper: classes.drawerPaper,
                }}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
              >
                {drawer}
              </Drawer>
            </Hidden>
            <Hidden smDown implementation="css">
              <Drawer
                variant="permanent"
                open
                classes={{
                  paper: classes.drawerPaper,
                }}
              >
                {drawer}
              </Drawer>
            </Hidden>
            <main className={classes.content}>
              <div className={classes.toolbar} style={{ justifyContent: 'center', alignContent: 'center'}}/>
              { children } 
            </main>
          </div>
        )
     }
 }

 export default withStyles(styles)(SideDrawer);


// WEBPACK FOOTER //
// ./src/components/sideDrawer/sideDrawer.jsx